module.exports = __webpack_public_path__ + "img/icon_4_12.a912cdad.png";